<template>
  <div>
    <video-modal :id="videoModal">
      <div class="video-modal">
        <!--        <video id="tour-video" width="100%" height="100%" controls="false">-->
        <!--          <source :src="videoSrc" type="video/mp4" />-->
        <!--        </video>-->
        <Player type="youtube" id="7_WuTK9fH9Y" />
        <!--        <div class="play-icon">-->
        <!--          <svg-->
        <!--            width="114"-->
        <!--            height="114"-->
        <!--            viewBox="0 0 114 114"-->
        <!--            fill="none"-->
        <!--            xmlns="http://www.w3.org/2000/svg"-->
        <!--          >-->
        <!--            <path-->
        <!--              fill-rule="evenodd"-->
        <!--              clip-rule="evenodd"-->
        <!--              d="M0.333252 56.9999C0.333252 25.7199 25.7199 0.333252 56.9999 0.333252C88.2799 0.333252 113.667 25.7199 113.667 56.9999C113.667 88.2799 88.2799 113.667 56.9999 113.667C25.7199 113.667 0.333252 88.2799 0.333252 56.9999ZM45.6666 31.4999V82.4999L79.6666 56.9999L45.6666 31.4999Z"-->
        <!--              fill="var(--theme-color)"-->
        <!--            />-->
        <!--          </svg>-->
        <!--        </div>-->
        <div class="close-icon" @click="$bvModal.hide(videoModal)">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="white" />
            <g clip-path="url(#clip0)">
              <path
                d="M16.7857 16.0008L22.9484 9.83807C23.1654 9.6211 23.1654 9.26932 22.9484 9.05238C22.7315 8.83543 22.3797 8.83541 22.1627 9.05238L16 15.2151L9.83734 9.05238C9.62037 8.83541 9.26859 8.83541 9.05164 9.05238C8.8347 9.26935 8.83467 9.62113 9.05164 9.83807L15.2143 16.0008L9.05164 22.1635C8.83467 22.3804 8.83467 22.7322 9.05164 22.9492C9.16012 23.0576 9.30231 23.1119 9.44451 23.1119C9.5867 23.1119 9.72887 23.0576 9.83737 22.9492L16 16.7865L22.1627 22.9492C22.2712 23.0576 22.4134 23.1119 22.5556 23.1119C22.6978 23.1119 22.8399 23.0576 22.9484 22.9492C23.1654 22.7322 23.1654 22.3804 22.9484 22.1635L16.7857 16.0008Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="14.2222"
                  height="14.2222"
                  fill="white"
                  transform="translate(8.88892 8.88892)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div class="footer">
        <b-button variant="primary btn-round-fill" @click="handleTakeTourClick">
          Take Tour</b-button
        >
        <b-button variant="light btn-simple" @click="handleGotItClick">
          Got it!</b-button
        >
      </div>
    </video-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VideoModal from "@/components/common/videoModal";
import { tourblog } from "@/components/common/tutorialAndTour/_tourBlog.json";
//import { tourblog } from "./_tourBlog.json";
import Vue from "vue";
import VueShepherd from "vue-shepherd";
import Player from "@/components/common/player";
Vue.use(VueShepherd);
export default {
  name: "tutorial-blogger",
  data() {
    return {
      videoModal: "tutorial-blogger",
      video: "https://vimeo.com/493091070",
      videoSrc:
        "https://player.vimeo.com/external/491704203.hd.mp4?s=d36c21a9e22d2734437ece3261422cd6b61ca9c6&profile_id=174",
      incompeleteBoarding: false
    };
  },
  props: {
    showVideo: {
      type: Boolean,
      default: false
    },
    tour: {
      type: Array,
      default: () => {
        return tourblog;
      }
    }
  },
  components: {
    VideoModal,
    Player
  },
  mounted() {
    if (this.showVideo) {
      this.$bvModal.show(this.videoModal);
    }
  },
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleGotItClick() {
      this.$bvModal.hide(this.videoModal);
      this.$store
        .dispatch("user/blogTutorialPlayed", "gotIt")
        .then(data => {})
        .catch(error => {
          console.log("Error getting document: ", error);
        });
      //let user know that it has been seen
    },
    handleTakeTourClick() {
      this.$bvModal.hide(this.videoModal);
      this.$store
        .dispatch("user/blogTutorialPlayed", "takeTour")
        .then(data => {})
        .catch(error => {
          console.log("Error getting document: ", error);
        });
      const tour = this.$shepherd({
        useModalOverlay: true
      });

      tourblog.forEach(step => {
        //swap actions
        if (step.buttons) {
          step.buttons.forEach(button => {
            button.action = this.swapFunc(tour, button.action);
          });
        }

        tour.addStep(step);
      });

      tour.start();
    },
    swapFunc(tour, methodName) {
      switch (methodName) {
        case "cancel":
          return tour.cancel;
        case "next":
          return tour.next;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~shepherd.js/dist/css/shepherd.css";

.video-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.footer {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
}
</style>
